import { Outlet } from 'react-router';

import { DelegationBar } from '@/component';
import { VFlex, VStack } from '@/package';
import { MainLayoutProvider } from '@/provider/layout';
import { useTenantStore } from '@/store';

import MainLayoutHeader from './MainLayoutHeader';
import MainLayoutSideBar from './MainLayoutSideBar';

const MainLayout = ({
  renderAboveHeader,
}: {
  renderAboveHeader?(): React.ReactElement;
}) => {
  const { isDelegationMode } = useTenantStore();

  return (
    <MainLayoutProvider>
      <VFlex className="h-screen w-full overflow-hidden">
        <VFlex className="flex h-full w-full flex-1 bg-white">
          <MainLayoutSideBar />
          <VStack
            role="presentation"
            className="h-full w-full flex-1 overflow-x-auto"
          >
            {isDelegationMode() && <DelegationBar />}
            {renderAboveHeader?.()}
            <MainLayoutHeader />
            <VStack className="flex-1 overflow-auto">
              <VFlex className="h-full w-full flex-1 overflow-x-auto overflow-y-hidden">
                <Outlet />
              </VFlex>
            </VStack>
          </VStack>
        </VFlex>
      </VFlex>
    </MainLayoutProvider>
  );
};

export default MainLayout;
